class RectMaskReveal extends Phaser.Group {
  constructor({ game }) {
    super(game);
    this.background = this.game.make.image(0, 0, 'bg_generic');
    this.add(this.background);

    this.render = this.render.bind(this);
    this.w = this.game.defaultWidth * 0.5;
    this.h = this.game.defaultHeight * 0.5;

    this.outer = this.generateOuter();
    this.maskp = this.game.add.graphics();
    this.maskp.anchor.set(0.5);
    this.maskp.position.set(this.w, this.h);
    this.addChild(this.maskp);
    this.background.mask = this.maskp;

    this.render(10);
    this.onInComplete = new Phaser.Signal();
    this.onOutComplete = new Phaser.Signal();
    this.game.input.enabled = false;
  }

  generateOuter() {
    const x1 = -this.w;
    const y1 = -this.h;
    const x2 = this.w;
    const y2 = this.h;
    return [x1, y1, x2, y1, x2, y2, x1, y2, x1, y1]; // outer coords of rect mask
  }

  render(step) {
    const ratio = this.w / this.h;
    const xx1 = Math.min(0, -(this.w - step * ratio));
    const yy1 = Math.min(0, -(this.h - step));
    const xx2 = Math.max(0, this.w - step * ratio);
    const yy2 = Math.max(0, this.h - step);
    let inner = [];
    if (yy1 !== 0 && yy2 !== 0) {
      inner = [xx1, yy1, xx2, yy1, xx2, yy2, xx1, yy2, xx1, yy1];
    }
    const ps = [...this.outer, ...inner];
    const poly = new Phaser.Polygon(ps);
    this.maskp.clear();
    this.maskp.beginFill(0x000000, 1);
    this.maskp.drawPolygon(poly.points);
    this.maskp.endFill();
  }

  init() {}

  startIn() {
    let track = { step: 0 };
    let tween = this.game.add.tween(track).to({ step: this.h + 1 }, RectMaskReveal.DURATION, Phaser.Easing.Circular.Out);
    tween.onUpdateCallback(() => {
      this.render(track.step);
    });
    tween.start();
    tween.onComplete.addOnce(this.startInComplete, this);
  }

  startInComplete() {
    this.onInComplete.dispatch(this);
  }

  startOut() {
    let track = { step: this.h + 1 };
    let tween = this.game.add.tween(track).to({ step: 0 }, RectMaskReveal.DURATION, Phaser.Easing.Circular.In);
    tween.onUpdateCallback(() => {
      this.render(track.step);
    });
    tween.start();
    tween.onComplete.addOnce(this.startOutComplete, this);
  }

  startOutComplete() {
    this.game.input.enabled = true;
    this.onOutComplete.dispatch(this);
  }

  destroy(destroyChildren = true, soft) {
    this.game.tweens.removeFrom(this, true);
    this.game.tweens.removeFrom(this);

    this.onInComplete.forget();
    this.onInComplete.dispose();
    this.onInComplete.removeAll();

    this.onOutComplete.forget();
    this.onOutComplete.dispose();
    this.onOutComplete.removeAll();

    this.background = null;
    this.maskp = null;
    super.destroy(destroyChildren);
  }
}
RectMaskReveal.DURATION = 500;
export default RectMaskReveal;
